import { useEffect, useState } from 'react';
import type { AdminApiOrganization } from '@/types/serializers';
import useUpdateAdminOrganization from '../../api/useUpdateAdminOrganization';
import { AdminButton } from '../AdminButton';
import AdminFormInput from '../atoms/AdminFormInput';
import AdminErrorMessage from '../atoms/AdminErrorMessage';
import { Switch } from '@/components/ui/switch';
import AdminModal from '../molecules/AdminModal';

type AdminOrganizationEditModalProps = {
  open: boolean;
  onClose: () => void;
  organization: AdminApiOrganization;
};

export default function AdminOrganizationEditModal({
  open,
  onClose,
  organization,
}: AdminOrganizationEditModalProps) {
  const [name, setName] = useState(organization.name);
  const [isPortalLoginEnabled, setIsPortalLoginEnabled] = useState(
    organization.is_portal_login_enabled
  );
  const [error, setError] = useState<string | null>(null);
  const { mutateAsync, isPending } = useUpdateAdminOrganization();

  useEffect(() => {
    if (open) {
      setName(organization.name);
      setIsPortalLoginEnabled(organization.is_portal_login_enabled);
      setError(null);
    }
  }, [open, organization.name, organization.is_portal_login_enabled]);

  const handleSubmit = async () => {
    try {
      await mutateAsync({
        id: organization.id,
        name,
        is_portal_login_enabled: isPortalLoginEnabled,
      });
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : '更新に失敗しました');
    }
  };

  return (
    <AdminModal
      open={open}
      onClose={onClose}
      title="クライアント情報の編集"
      maxWidth="max-w-[600px]"
      footer={
        <div className="flex justify-end">
          <AdminButton
            label={isPending ? '保存中...' : '保存する'}
            disabled={isPending}
            onClick={handleSubmit}
          />
        </div>
      }
    >
      <div className="flex flex-col gap-4">
        <AdminFormInput label="企業名" value={name} onChange={(e) => setName(e.target.value)} />
        <div className="flex items-center justify-between gap-4">
          <div className="flex flex-col gap-1">
            <label htmlFor="portal-login-enabled" className="text-sm font-bold text-main">
              マイページログイン機能
            </label>
            <span className="text-xs text-sub">
              ONにすると、エージェントが候補者ごとにマイページのログインを必須にできます
            </span>
          </div>
          <Switch
            id="portal-login-enabled"
            checked={isPortalLoginEnabled}
            onCheckedChange={setIsPortalLoginEnabled}
          />
        </div>
        <AdminErrorMessage message={error} />
      </div>
    </AdminModal>
  );
}
